import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FAIL, LOADING, SUCCESS } from '../../redux_store/actionTypes';
import { getConfig, updateConfig } from '../../redux_store/config/config_thunk';
import { convertFromCedisToPesewas, convertFromPesewasToCedis } from '../../utils';
import Button from '../templates/Button';
import InputField from '../templates/InputField';
import SwitchToggle from '../templates/SwitchToggle';
import toast from '../templates/ToastMessage';
import LoadingModal from '../templates/modals/LoadingModal';

const SettingsPage = () => {
  const [details, setDetails] = useState({});
  const dispatch = useDispatch();
  const { status, message, configuration } = useSelector((state)=>state.config);

  useEffect(()=>{
    dispatch(getConfig());
    // eslint-disable-next-line
  }, []);

  useEffect(()=>{
    if(configuration){
      setDetails({
        ...configuration,
        booking_fee: convertFromPesewasToCedis(configuration.booking_fee),
        per_min_price: convertFromPesewasToCedis(configuration.per_min_price),
        per_mile_price: convertFromPesewasToCedis(configuration.per_mile_price),
        driver_minimum_acc_balance: convertFromPesewasToCedis(configuration.driver_minimum_acc_balance),
        driver_minimum_withdrawal_amt: convertFromPesewasToCedis(configuration.driver_minimum_withdrawal_amt),
        minimum_credit_balance: convertFromPesewasToCedis(configuration.minimum_credit_balance),
      });
    }
  }, [configuration]);

  useEffect(()=>{
    if(status === FAIL){
      toast({message, status});
    }else if(status === SUCCESS){
      toast({message, status});
    }
    // eslint-disable-next-line
  }, [status]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if(isNaN(details.per_mile_price) || isNaN(details.per_min_price) || isNaN(details.booking_fee)){
      return toast({message: 'Kindly enter right value for all fields', status: 'fail'});
    }
    dispatch(updateConfig({
      ...details,
      booking_fee: convertFromCedisToPesewas(details.booking_fee),
      per_min_price: convertFromCedisToPesewas(details.per_min_price),
      per_mile_price: convertFromCedisToPesewas(details.per_mile_price),
      driver_minimum_acc_balance: convertFromCedisToPesewas(details.driver_minimum_acc_balance),
      driver_minimum_withdrawal_amt: convertFromCedisToPesewas(details.driver_minimum_withdrawal_amt),
      minimum_credit_balance: convertFromCedisToPesewas(details.minimum_credit_balance),
    }));
  }

  const handleInputChange = (e) => {
    const {name, value} = e.target;
    setDetails({ ...details, [name]: value});
  }

  return (
    <form onSubmit={handleFormSubmit} className='grid gap-y-5 gap-x-8 py-10 px-10 grid-cols-6 bg-white shadow-md rounded'>
      {status === LOADING && <LoadingModal message={'Please wait...'} />}
      <p className='wayrideColor col-span-4 font-bold uppercase text-sm'>Pricing</p>      
      <div className='grid col-span-6 gap-10 grid-cols-4'>
        <div>
          <p className='text-gray-500 mb-1 font-medium text-sm'>Booking Fee (GHC)</p>
          <InputField 
            type={'text'}
            name="booking_fee"
            onChange={handleInputChange}
            value={details.booking_fee}
          />
        </div>
        <div>
          <p className='text-gray-500 mb-1 font-medium text-sm'>
            Per minute price (GHC)
          </p>
          <InputField 
            type={'text'}
            name="per_min_price"
            onChange={handleInputChange}
            value={details.per_min_price}
          />
        </div>
        <div>
          <p className='text-gray-500 mb-1 font-medium text-sm'>
            Per mile price (GHC)
          </p>
          <InputField 
            type={'text'}
            name="per_mile_price"
            onChange={handleInputChange}
            value={details.per_mile_price}
          />
        </div>
        <div>
          <p className='text-gray-500 mb-1 font-medium text-sm'>
            Ride credit rate (GHC)
          </p>
          <InputField 
            type={'text'}
            name="ride_credit_rate"
            onChange={handleInputChange}
            value={details.ride_credit_rate}
          />
        </div>
        <div>
          <p className='text-gray-500 mb-1 font-medium text-sm'>
            Driver Commision ( In % )
          </p>
          <InputField 
            type={'text'}
            name="driver_commission"
            onChange={handleInputChange}
            value={details.driver_commission}
          />
        </div>
        <div>
          <p className='text-gray-500 mb-1 font-medium text-sm'>
            Driver Minimum Withdrawal (GHC)
          </p>
          <InputField 
            type={'text'}
            name="driver_minimum_withdrawal_amt"
            onChange={handleInputChange}
            value={(details.driver_minimum_withdrawal_amt)}
          />
        </div>
        <div>
          <p className='text-gray-500 mb-1 font-medium text-sm'>
            Minimum Credit Balance (GHC)
          </p>
          <InputField 
            type={'text'}
            name="minimum_credit_balance"
            onChange={handleInputChange}
            value={(details.minimum_credit_balance)}
          />
        </div>
        <div>
          <p className='text-gray-500 mb-1 font-medium text-sm'>
            Driver Minimum Balance (GHC)
          </p>
          <InputField 
            type={'text'}
            name="driver_minimum_acc_balance"
            onChange={handleInputChange}
            value={(details.driver_minimum_acc_balance)}
          />
        </div>
      </div>
      <p className='wayrideColor col-span-4 font-bold uppercase text-sm'>App Version</p>      
      <div className='grid col-span-6 gap-10 grid-cols-4'>
        <div>
          <p className='text-gray-500 mb-1 font-medium text-sm'>Customer App Version</p>
          <InputField 
            type={'text'}
            name="customers_app_version"
            onChange={handleInputChange}
            value={details.customers_app_version}
          />
        </div>
        <div>
          <p className='text-gray-500 mb-1 font-medium text-sm'>
            Driver App Version
          </p>
          <InputField 
            type={'text'}
            name="driver_app_version"
            onChange={handleInputChange}
            value={details.driver_app_version}
          />
        </div>
      </div>
      <p className='wayrideColor col-span-5 font-bold uppercase text-sm'>System</p>
      <SwitchToggle
        state={details.driver_maintenanace_mode}
        label={'Put Driver in maintenance mode'}
        onSwitch={() =>
          setDetails({ ...details, driver_maintenanace_mode: !details.driver_maintenanace_mode })
        }
        onColor='wayrideBgColor'
        offColor='bg-gray-300'
      />
      
      <SwitchToggle
        state={details.logout_driver_accounts}
        label={'Force Driver Accounts logout'}
        onSwitch={() =>
          setDetails({ ...details, logout_driver_accounts: !details.logout_driver_accounts })
        }
        onColor='wayrideBgColor'
        offColor='bg-gray-300'
      />
      <SwitchToggle 
        state={details.force_driver_updates} 
        label={'Force Drivers Update'}
        onSwitch={()=>
          setDetails({...details, force_driver_updates: !details.force_driver_updates})
        } 
        onColor='wayrideBgColor'
        offColor='bg-gray-300'
      />
      
      <SwitchToggle 
        state={details.customer_maintenanace_mode} 
        label={'Put Customer in maintenance mode'}
        onSwitch={()=>
          setDetails({ ...details, customer_maintenanace_mode: !details.customer_maintenanace_mode})
        } 
        onColor='wayrideBgColor'
        offColor='bg-gray-300'
      />
      <SwitchToggle 
        state={details.logout_customer_accounts} 
        label={'Force Customer Accounts logout'}
        onSwitch={()=>
          setDetails({ ...details, logout_customer_accounts: !details.logout_customer_accounts })
        } 
        onColor='wayrideBgColor'
        offColor='bg-gray-300'
      />
      <SwitchToggle
        state={details.force_customer_updates}
        label={'Force Customers Update'}
        onSwitch={() =>
          setDetails({ ...details, force_customer_updates: !details.force_customer_updates })
        }
        onColor='wayrideBgColor'
        offColor='bg-gray-300'
      />
      <div className='col-span-6'>
        <Button
          type="submit"
          label={'Update'}
          width="w-full"
          bgColor={'wayrideBgColor'}
        />
      </div>
    </form>  
  )
}

export default SettingsPage